<div class="cfg-page">

  <div class="page-header">
    <div class="page-header__info">
      <h1 class="page-header__title"><i class="fal fa-warehouse"></i> Centres de Tri</h1>
      <p class="page-header__sub">Gestion des hubs et entrepôts — {{ centres.length }} centre(s)</p>
    </div>
    <div class="header-actions">
      <button class="btn-create" (click)="ouvrirCreation()"><i class="fal fa-plus"></i> Nouveau centre</button>
      <button class="btn-refresh" (click)="charger()" [disabled]="chargement">
        <i class="fal fa-sync" [class.fa-spin]="chargement"></i> Actualiser
      </button>
    </div>
  </div>

  <!-- KPIs -->
  <div class="kpi-row">
    <div class="kpi-card"><span class="kpi-val">{{ centres.length }}</span><span class="kpi-label">Total</span></div>
    <div class="kpi-card kpi-card--green"><span class="kpi-val">{{ actifs }}</span><span class="kpi-label">Actifs</span></div>
    <div class="kpi-card kpi-card--grey"><span class="kpi-val">{{ inactifs }}</span><span class="kpi-label">Inactifs</span></div>
  </div>

  <!-- Filtres -->
  <div class="filtres-bar">
    <div class="filtre-search">
      <i class="fal fa-search"></i>
      <input type="text" [(ngModel)]="recherche" (ngModelChange)="appliquerFiltres()" placeholder="Nom, ville, responsable…" />
    </div>
    <select class="filtre-select" [(ngModel)]="filtreActif" (ngModelChange)="appliquerFiltres()">
      <option value="">Tous les statuts</option>
      <option value="actif">Actifs</option>
      <option value="inactif">Inactifs</option>
    </select>
  </div>

  <!-- Chargement -->
  <div class="etat-centre" *ngIf="chargement"><div class="spinner"></div><span>Chargement…</span></div>

  <!-- Vide -->
  <div class="etat-centre" *ngIf="!chargement && centresFiltres.length === 0">
    <i class="fal fa-warehouse" style="font-size:36px;color:#cbd5e0"></i>
    <p>Aucun centre de tri trouvé.</p>
  </div>

  <!-- Tableau -->
  <div class="table-wrapper" *ngIf="!chargement && centresFiltres.length > 0">
    <table class="data-table">
      <thead>
        <tr>
          <th>Nom</th>
          <th>Ville</th>
          <th>Zones</th>
          <th>Responsable</th>
          <th>Téléphone</th>
          <th>Statut</th>
          <th>Actions</th>
        </tr>
      </thead>
      <tbody>
        <tr *ngFor="let c of centresFiltres">
          <td><strong>{{ c.nom }}</strong></td>
          <td>{{ c.villeNom || '—' }}</td>
          <td>
            <ng-container *ngIf="c.zoneNoms && c.zoneNoms.length > 0">
              <span *ngFor="let z of c.zoneNoms" class="statut-badge badge--teal" style="margin-right:2px">{{ z }}</span>
            </ng-container>
            <span *ngIf="!c.zoneNoms || c.zoneNoms.length === 0" class="text-muted">—</span>
          </td>
          <td>{{ c.responsableNom || '—' }}</td>
          <td>{{ c.telephone || '—' }}</td>
          <td>
            <span class="statut-badge" [ngClass]="c.actif ? 'badge--vert' : 'badge--gris'">
              {{ c.actif ? 'Actif' : 'Inactif' }}
            </span>
          </td>
          <td>
            <div class="actions-cell">
              <button class="btn-action btn-action--teal" (click)="ouvrirEdition(c)" title="Modifier">
                <i class="fal fa-pencil"></i>
              </button>
              <button class="btn-action" [ngClass]="c.actif ? 'btn-action--orange' : 'btn-action--green'"
                      (click)="activerDesactiver(c)" [title]="c.actif ? 'Désactiver' : 'Activer'">
                <i class="fal" [ngClass]="c.actif ? 'fa-ban' : 'fa-check'"></i>
              </button>
              <button class="btn-action btn-action--danger" (click)="supprimer(c)" title="Supprimer">
                <i class="fal fa-trash"></i>
              </button>
            </div>
          </td>
        </tr>
      </tbody>
    </table>
  </div>
</div>

<!-- MODAL -->
<div class="modal-backdrop ctr-modal-backdrop" *ngIf="afficherModal" (click)="fermerModal()">
  <div class="modal-card modal-card--large ctr-modal" (click)="$event.stopPropagation()">

    <!-- Header gradient -->
    <div class="ctr-modal-header">
      <div class="ctr-modal-header__band"></div>
      <div class="ctr-modal-header__content">
        <div class="ctr-modal-header__icon">
          <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" width="26" height="26">
            <path d="M3 9l9-7 9 7v11a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2z"/>
            <polyline points="9 22 9 12 15 12 15 22"/>
          </svg>
        </div>
        <div class="ctr-modal-header__text">
          <h3 class="ctr-modal-header__title">{{ modeEdition ? 'Modifier le centre' : 'Nouveau centre de tri' }}</h3>
          <p class="ctr-modal-header__sub">{{ modeEdition ? 'Mettez à jour les informations du hub' : 'Renseignez les informations du hub logistique' }}</p>
        </div>
        <div class="ctr-modal-header__badge" *ngIf="modeEdition"><span>Édition</span></div>
        <button class="modal-close ctr-modal-close" (click)="fermerModal()"><i class="fal fa-times"></i></button>
      </div>
    </div>

    <div class="modal-body ctr-modal-body">

      <!-- Section 1 : Identification -->
      <div class="ctr-section">
        <div class="ctr-section__label">
          <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" width="13" height="13"><circle cx="12" cy="12" r="10"/><line x1="12" y1="8" x2="12" y2="12"/><line x1="12" y1="16" x2="12.01" y2="16"/></svg>
          Identification
        </div>
        <div class="modal-grid ctr-grid">
          <!-- Nom -->
          <div class="modal-field modal-field--full ctr-field">
            <label>Nom du centre <span class="required">*</span></label>
            <div class="ctr-input-wrap">
              <svg class="ctr-input-icon" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" width="15" height="15"><path d="M3 9l9-7 9 7v11a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2z"/><polyline points="9 22 9 12 15 12 15 22"/></svg>
              <input type="text" [(ngModel)]="formulaire.nom" placeholder="Ex: Hub Abidjan Nord" class="ctr-input" />
            </div>
          </div>
          <!-- Ville -->
          <div class="modal-field ctr-field">
            <label>Ville</label>
            <div class="ctr-input-wrap ctr-input-wrap--select">
              <svg class="ctr-input-icon" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" width="15" height="15"><path d="M3 9l9-7 9 7v11a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2z"/></svg>
              <select [(ngModel)]="formulaire.villeId" (ngModelChange)="onVilleChange()" class="ctr-input ctr-select">
                <option [ngValue]="undefined">— Sélectionner une ville —</option>
                <option *ngFor="let v of villes" [ngValue]="v.id">{{ v.nom }}</option>
              </select>
            </div>
          </div>
          <!-- Zones (multi-sélection filtrée par ville) -->
          <div class="modal-field ctr-field modal-field--full">
            <label class="ctr-zones-label">
              Zones associées
              <span class="ctr-zones-hint" *ngIf="!formulaire.villeId">— sélectionnez une ville pour filtrer</span>
              <span class="ctr-zones-count" *ngIf="formulaire.zoneIds && formulaire.zoneIds.length > 0">
                {{ formulaire.zoneIds.length }} sélectionnée(s)
              </span>
            </label>
            <div class="ctr-zones-pills" *ngIf="zonesFiltreesParVille.length > 0; else noZones">
              <button
                type="button"
                *ngFor="let z of zonesFiltreesParVille"
                class="ctr-zone-pill"
                [class.ctr-zone-pill--active]="zoneSelectionnee(z.id)"
                (click)="toggleZone(z.id)">
                <span class="ctr-zone-pill__check" *ngIf="zoneSelectionnee(z.id)">✓</span>
                {{ z.nom }}
              </button>
            </div>
            <ng-template #noZones>
              <div class="ctr-zones-empty">
                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" width="20" height="20"><path d="M21 10c0 7-9 13-9 13s-9-6-9-13a9 9 0 0 1 18 0z"/><circle cx="12" cy="10" r="3"/></svg>
                <span *ngIf="!formulaire.villeId">Sélectionnez d'abord une ville</span>
                <span *ngIf="formulaire.villeId">Aucune zone pour cette ville</span>
              </div>
            </ng-template>
          </div>
        </div>
      </div>

      <!-- Section 2 : Contact & Responsable -->
      <div class="ctr-section">
        <div class="ctr-section__label">
          <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" width="13" height="13"><path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2"/><circle cx="12" cy="7" r="4"/></svg>
          Contact &amp; Responsable
        </div>
        <div class="modal-grid ctr-grid">
          <!-- Responsable (dropdown RESPONSABLE_ZONE) -->
          <div class="modal-field ctr-field">
            <label>Responsable de zone</label>
            <div class="ctr-input-wrap ctr-input-wrap--select">
              <svg class="ctr-input-icon" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" width="15" height="15"><path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2"/><circle cx="12" cy="7" r="4"/></svg>
              <select [(ngModel)]="formulaire.responsableId" class="ctr-input ctr-select">
                <option [ngValue]="undefined">— Sélectionner un responsable —</option>
                <option *ngFor="let r of responsablesZone" [ngValue]="r.id">{{ r.nom }} {{ r.prenom }}</option>
              </select>
            </div>
          </div>
          <!-- Téléphone -->
          <div class="modal-field ctr-field">
            <label>Téléphone</label>
            <div class="ctr-input-wrap">
              <svg class="ctr-input-icon" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" width="15" height="15"><path d="M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07A19.5 19.5 0 0 1 4.69 13.5 19.79 19.79 0 0 1 1.62 4.89 2 2 0 0 1 3.59 2.68l3-.01a2 2 0 0 1 2 1.72 12.84 12.84 0 0 0 .7 2.81 2 2 0 0 1-.45 2.11L7.91 9.91a16 16 0 0 0 6.29 6.29l1.38-1.38a2 2 0 0 1 2.11-.45 12.84 12.84 0 0 0 2.81.7A2 2 0 0 1 22 16.92z"/></svg>
              <input type="text" [(ngModel)]="formulaire.telephone" placeholder="+225 07 XX XX XX XX" class="ctr-input" autocomplete="new-password" />
            </div>
          </div>
          <!-- Email -->
          <div class="modal-field ctr-field">
            <label>Email</label>
            <div class="ctr-input-wrap">
              <svg class="ctr-input-icon" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" width="15" height="15"><path d="M4 4h16c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2z"/><polyline points="22,6 12,13 2,6"/></svg>
              <input type="email" [(ngModel)]="formulaire.email" placeholder="centre@dematral.ci" class="ctr-input" />
            </div>
          </div>
        </div>
      </div>

      <!-- Section 3 : Statut -->
      <div class="ctr-section ctr-section--last">
        <div class="ctr-section__label">
          <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" width="13" height="13"><circle cx="12" cy="12" r="10"/><polyline points="12 6 12 12 16 14"/></svg>
          Statut
        </div>
        <div class="ctr-grid">
          <div class="ctr-toggle-row">
            <div class="ctr-toggle-info">
              <div class="ctr-toggle-dot" [class.ctr-toggle-dot--on]="formulaire.actif"></div>
              <div>
                <span class="ctr-toggle-title">Centre actif</span>
                <span class="ctr-toggle-desc">{{ formulaire.actif ? 'Ce centre reçoit et expédie des colis' : 'Ce centre est hors service' }}</span>
              </div>
            </div>
            <label class="toggle-switch ctr-toggle">
              <input type="checkbox" [(ngModel)]="formulaire.actif" />
              <span class="toggle-slider"></span>
            </label>
          </div>
        </div>
      </div>

    </div>

    <div class="modal-footer ctr-modal-footer">
      <button class="btn-modal-cancel" (click)="fermerModal()">
        <i class="fal fa-times"></i> Annuler
      </button>
      <button class="btn-modal-primary" (click)="sauvegarder()" [disabled]="sauvegardeEnCours">
        <ng-container *ngIf="!sauvegardeEnCours">
          <i class="fal" [ngClass]="modeEdition ? 'fa-save' : 'fa-plus'"></i>
          {{ modeEdition ? 'Enregistrer les modifications' : 'Créer le centre' }}
        </ng-container>
        <ng-container *ngIf="sauvegardeEnCours">
          <div class="spinner spinner--xs spinner--white"></div> Enregistrement…
        </ng-container>
      </button>
    </div>
  </div>
</div>

